module.exports = __webpack_public_path__ + "static/img/logo-kl8.d0f8cc35.png";